var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App Icon",
    clipPath: "url(#clip0_6002_40545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1263 30.2218V4.97734C16.1263 3.85724 16.1263 3.29719 15.9083 2.86936C15.7166 2.49304 15.4106 2.18708 15.0343 1.99533C14.6065 1.77734 14.0464 1.77734 12.9263 1.77734H8.88845H4.97734C3.85724 1.77734 3.29719 1.77734 2.86936 1.99533C2.49304 2.18708 2.18708 2.49304 1.99533 2.86936C1.77734 3.29719 1.77734 3.85724 1.77734 4.97734V27.0218C1.77734 28.1419 1.77734 28.7019 1.99533 29.1298C2.18708 29.5061 2.49304 29.8121 2.86936 30.0038C3.29719 30.2218 3.85724 30.2218 4.97734 30.2218H16.1263Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.3492 27.0229V16.534C30.3492 15.4139 30.3492 14.8538 30.1312 14.426C29.9394 14.0497 29.6335 13.7437 29.2572 13.552C28.8293 13.334 28.2693 13.334 27.1492 13.334H23.2381H16.127V30.2229H27.1492C28.2693 30.2229 28.8293 30.2229 29.2572 30.0049C29.6335 29.8131 29.9394 29.5072 30.1312 29.1309C30.3492 28.703 30.3492 28.143 30.3492 27.0229Z",
    fill: "#D9D9D9",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.9047 27.0231V22.3856C25.9047 21.6138 25.9047 21.2279 25.7996 20.9166C25.6 20.3253 25.1358 19.8612 24.5445 19.6615C24.2333 19.5564 23.8474 19.5564 23.0755 19.5564C22.477 19.5564 22.1778 19.5564 21.8858 19.522C21.3354 19.457 20.7996 19.301 20.3004 19.0603C20.0355 18.9326 19.7831 18.7719 19.2782 18.4506L19.2782 18.4506L16.127 16.4453V30.2231H22.7047C23.8248 30.2231 24.3849 30.2231 24.8127 30.0051C25.189 29.8134 25.495 29.5074 25.6867 29.1311C25.9047 28.7032 25.9047 28.1432 25.9047 27.0231Z",
    fill: "#D9D9D9",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 267",
    d: "M5.45996 6.22266L12.5711 6.22266",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 268",
    d: "M5.45996 9.77734L12.5711 9.77734",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 269",
    d: "M5.45996 13.334L12.5711 13.334",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 270",
    d: "M5.45996 16.8887L12.5711 16.8887",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 271",
    d: "M5.45996 20.4453L12.5711 20.4453",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 272",
    d: "M5.45996 24L9.01552 24",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6002_40545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/app_icon.7764985caaa849814c52bab9878d4b11.svg";